import React from "react";
import { ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TriggerBadge from "./TriggerBadge";
import StepProgressBar from "./StepProgressBar";

function ExecutionCard({ execution, onViewDetails, style }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const formatTime = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return d.toLocaleDateString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
    };

    const formatDuration = (s, c) => {
        if (!s) return "-";
        const ms = (c ? new Date(c) : new Date()) - new Date(s);
        if (ms < 1000) return "< 1s";
        if (ms < 60000) return `${Math.round(ms / 1000)}s`;
        if (ms < 3600000) return `${Math.round(ms / 60000)}m`;
        return `${Math.round(ms / 3600000)}h`;
    };

    return (
        <div className="border rounded p-2.5 hover:shadow-sm transition-shadow cursor-pointer bg-card text-[11px] h-full flex flex-col justify-between" style={style} onClick={() => onViewDetails(execution)}>
            <div>
                <div className="flex items-center justify-between mb-1">
                    <h3 className="font-medium text-xs truncate pr-1 leading-tight">{execution.workflowName}</h3>
                    <button onClick={(e) => { e.stopPropagation(); navigate(`/chat/${execution.workflowId}/chat`); }} className="text-muted-foreground hover:text-foreground shrink-0" title={t("monitoring.card.openWorkflow")}>
                        <ExternalLink className="h-3 w-3" />
                    </button>
                </div>
                <div className="flex items-center gap-2 mb-1">
                    {execution.totalSteps > 0 && <StepProgressBar stepProgress={execution.stepProgress} totalSteps={execution.totalSteps} />}
                    {execution.triggerTypes.map((type) => <TriggerBadge key={type} type={type} />)}
                </div>
            </div>
            <div className="flex justify-between text-muted-foreground">
                <span>{formatTime(execution.startedAt)}</span>
                <span>{formatDuration(execution.startedAt, execution.completedAt)}</span>
            </div>
        </div>
    );
}

export default ExecutionCard;
